/**
 * Deposit calculation helpers for the rental create/edit forms.
 *
 * Background (S152): when a rental item is granted free-deposit (deposit_waived),
 * the form forces `deposit_amount` to 0 so the waived item is excluded from the
 * company deposit cap. The "ประหยัด X บาท" savings indicator must therefore read the
 * pre-waive amount kept in `_prev_deposit_amount`, NOT the now-zeroed `deposit_amount`
 * (reading deposit_amount made the indicator always show 0 — the headline benefit died).
 */
export interface DepositCalcItem {
  deposit_waived?: boolean;
  deposit_amount?: number;
  /** the deposit amount captured right before the waive toggle zeroed deposit_amount */
  _prev_deposit_amount?: number;
}

/** Total amount waived across all free-deposit items (the "ประหยัด" figure). */
export function computeWaivedSavings(items: DepositCalcItem[]): number {
  return items.reduce(
    (sum, item) => sum + (item.deposit_waived ? (item._prev_deposit_amount || 0) : 0),
    0,
  );
}

/** Number of items granted free-deposit. */
export function countWaivedItems(items: DepositCalcItem[]): number {
  return items.filter((item) => item.deposit_waived).length;
}

/** Deposit that counts toward the company cap (waived items contribute 0). */
export function computeUsedDeposit(items: DepositCalcItem[]): number {
  return items.reduce(
    (sum, item) => sum + (item.deposit_waived ? 0 : (item.deposit_amount || 0)),
    0,
  );
}
